import { ReactComponent as HamburgerMenuIcon } from "../../../svgs/hambugger.svg";
import { IconButton } from "@mui/material";
import styles from "./header.module.scss";

interface HeaderProps {
  handleSidebarToggle?: () => void;
}

const Header: React.FC<HeaderProps> = ({ handleSidebarToggle }) => {
  return (
    <div className={styles.header}>
      <IconButton
        aria-label="open sidebar"
        edge="start"
        onClick={handleSidebarToggle}
        sx={{ visibility: { xs: "visible", md: "hidden" } }}
      >
        <HamburgerMenuIcon />
      </IconButton>
    </div>
  );
};

export default Header;
